import { useEffect, useContext } from "react";
import { useNavigate } from "react-router-dom";

// context
import context from "../../store/context";

// hooks
import useInput from "../../hooks/use-Input";

// components
import CustomDropdown from "../Dropdown";
import AuthenticationButton from "../Buttons/AuthenticationButton";

//icons
import SearchIcon from "../icons/Search";
import LanguageIcon from "../icons/Language";
import TagIcon from "../icons/Tag";
import MapIcon from "../icons/Map";

const SearchSidebar = (props) => {
  const {
    categoryLists,
    regions,
    language,
    feedCategoryLists,
    feedRegions,
    feedLanguage,
    searchingTitle,
    setSearchingTitle,
    setSearchingCategoryId,
    setSearchingRegionId,
    setSearchingLanguageId,
    SearchTenders,
    selectedStatus,
    setSelectedStatus,
    tendersCategoryLists,
    tendersRegions,
    tendersLanguage,
  } = useContext(context);

  const { enteredValue, valueChangeHandler } = useInput(
    () => true,
    searchingTitle || ""
  );

  useEffect(() => {
    setSearchingTitle(() => enteredValue);
  }, [enteredValue, setSearchingTitle]);

  const handleOptionSelect = (option, dropdownId) => {
    if (dropdownId === 1) {
      setSearchingLanguageId(option);
    } else if (dropdownId === 2) {
      setSearchingRegionId(option);
    } else {
      if (option !== null) {
        setSearchingCategoryId(option);
      }
    }
  };

  const statuses = [
    { id: "", name: "All", activeColor: "text-[#3d5984]" },
    { id: "1", name: "Open", activeColor: "text-green-600" },
    { id: "0", name: "Closed", activeColor: "text-red-500" },
  ];
  const statusIndex = Math.max(
    0,
    statuses.findIndex((s) => s.id === selectedStatus)
  );

  const navigate = useNavigate();

  const searchSubmitHandler = (event) => {
    event.preventDefault();

    SearchTenders();
    if (props.redirect) {
      navigate("/tenders");
    }
  };
  return (
    <form type="submit" className="w-full flex flex-col">
      <div className="w-full md:h-[60px] mb-5 hidden md:flex items-center justify-center bg-[#664bc7]/5 text-[#664bc7]/70 text-lg rounded-b-md font-semibold">
        <h1>
          Search{" "}
          {props.filter === "myfeed"
            ? "My Feed"
            : props.filter === "saved"
            ? "Saved"
            : "Tenders"}
        </h1>
      </div>
      <div className="mb-6">
        <label
          htmlFor="searchText"
          className="block text-sm font-medium text-gray-500 mb-2"
        >
          Title
        </label>
        <div className="relative">
          <SearchIcon styles="w-5 h-5 absolute left-3.5 top-1/2 -translate-y-1/2 text-gray-400" />
          <input
            id="searchText"
            type="text"
            value={enteredValue}
            onChange={valueChangeHandler}
            placeholder="Search by title"
            className="w-full h-12 pl-11 pr-4 rounded-xl bg-gray-100 text-[15px] text-gray-700 placeholder-gray-400 border border-transparent focus:outline-none focus:bg-white focus:border-[#664bc7]/40 focus:ring-2 focus:ring-[#664bc7]/15 transition-colors"
          />
        </div>
      </div>

      <div className="flex flex-col w-full space-y-7 text-gray-500">
        <div className="flex flex-col space-y-3">
          <div className="flex items-center">
            <LanguageIcon styles="w-4 h-4 mr-2" />
            <h1 className="font-medium text-sm  text-gray-500">Language</h1>
          </div>
          <CustomDropdown
            options={
              props.filter === ""
                ? tendersLanguage
                : props.filter === "myfeed"
                ? feedLanguage
                : language
            }
            defaultValue={"All"}
            onSelect={handleOptionSelect}
            dropdownId={1}
          />
        </div>
        <div className="flex flex-col space-y-3">
          <div className="flex items-center">
            <MapIcon styles="w-4 h-4 mr-2" />
            <h1 className="font-medium  text-sm text-gray-500">Regions</h1>
          </div>
          <CustomDropdown
            options={
              props.filter === ""
                ? tendersRegions
                : props.filter === "myfeed"
                ? feedRegions
                : regions
            }
            defaultValue={"All"}
            onSelect={handleOptionSelect}
            dropdownId={2}
          />
        </div>
        <div className="flex flex-col space-y-3">
          <div className="flex items-center">
            <TagIcon styles="w-4 h-4 mr-2" />
            <h1 className="font-medium text-sm  text-gray-500">Category</h1>
          </div>
          <CustomDropdown
            options={
              props.filter === ""
                ? tendersCategoryLists
                : props.filter === "myfeed"
                ? feedCategoryLists
                : categoryLists
            }
            defaultValue={"All"}
            onSelect={handleOptionSelect}
            dropdownId={3}
          />
        </div>
      </div>
      <div className="py-7">
        <h1 className="font-medium text-sm text-gray-500 mb-3">Status</h1>
        <div className="relative flex bg-gray-100 p-1 rounded-full">
          <div
            className="absolute top-1 bottom-1 left-1 rounded-full bg-white shadow-sm transition-transform duration-300 ease-out"
            style={{
              width: "calc((100% - 8px) / 3)",
              transform: `translateX(${statusIndex * 100}%)`,
            }}
          />
          {statuses.map((status) => (
            <button
              key={status.id || "all"}
              type="button"
              onClick={() => setSelectedStatus(status.id)}
              className={`relative z-10 flex-1 py-2 text-sm rounded-full transition-colors duration-200 ${
                selectedStatus === status.id
                  ? `font-semibold ${status.activeColor}`
                  : "text-gray-500"
              }`}
            >
              {status.name}
            </button>
          ))}
        </div>
      </div>
      <AuthenticationButton
        onClick={searchSubmitHandler}
        name="Search"
        className="w-full h-12 bg-[#664bc7] hover:bg-[#664bc7]/90 text-white rounded-xl font-semibold transition-colors relative overflow-hidden"
      />
    </form>
  );
};

export default SearchSidebar;
